import { useState } from "react"
import styles from "./games.module.css"

export default function GamesOffered() {
  const games = [
    { name: "Mobile Legends", icon: "⚔️", category: "MOBA" },
    { name: "Valorant", icon: "🎯", category: "FPS" },
    { name: "PUBG", icon: "🔫", category: "Battle Royale" },
    { name: "Genshin Impact", icon: "✨", category: "RPG" },
    { name: "Identity V", icon: "🕵️", category: "Asymmetric" },
    { name: "Dead by Daylight", icon: "👻", category: "Horror" },
    { name: "Free Fire", icon: "🔥", category: "Battle Royale" },
    { name: "Harry Potter: Magic Awakened", icon: "🪄", category: "Card Game" },
    { name: "All Esports: Mobile", icon: "📱", category: "Esport" },
    { name: "All Esports: PC", icon: "🎮", category: "Esport" },
  ]

  const [hoveredGame, setHoveredGame] = useState(null)

  return (
    <section className={styles.games}>
      <h2 className={styles.sectionTitle}>Supported Games</h2>
      <p className={styles.subtitle}>Your favorite games, fair prices, instant delivery</p>

      <div className={styles.gameGrid}>
        {games.map((game, idx) => (
          <div
            key={idx}
            className={`${styles.gameCard} ${hoveredGame === idx ? styles.hovered : ""}`}
            onMouseEnter={() => setHoveredGame(idx)}
            onMouseLeave={() => setHoveredGame(null)}
          >
            <div className={styles.gameIcon}>{game.icon}</div>
            <h3 className={styles.gameName}>{game.name}</h3>
            <span className={styles.gameCategory}>{game.category}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
